const buildCriteriaString = (collections, brands) => {
  const criteriaParts = [];
  
  // Add brand criteria
  if (brands.length > 0) {
    if (brands.length === 1) {
      criteriaParts.push(`brand:${brands[0]}`);
    } else {
      criteriaParts.push('brand:*');
    }
  }
  
  // Add collection criteria
  if (collections.length > 0) {
    if (collections.length === 1) {
      criteriaParts.push(`collection:${collections[0]}`);
    } else {
      criteriaParts.push('collection:*');
    }
  }
  
  return criteriaParts.join(',');
};

// @todo consider using https://github.com/CacheControl/json-rules-engine
const findMatchingDetails = (collections, brands, metaData) => {
  const collectionConfigs = metaData.collections;
  
  // Build the most specific criteria first
  const specificCriteria = buildCriteriaString(collections, brands);
  
  // Try exact match first
  let match = collectionConfigs.find(config => config.criteria === specificCriteria);
  if (match) {
    return match;
  }
  
  // If no exact match, try progressively more general patterns
  const fallbackPatterns = [];
  
  // For combined searches, prioritize combination patterns over individual ones
  if (brands.length > 0 && collections.length > 0) {
    fallbackPatterns.push(`brand:${brands[0]},collection:${collections[0]}`);
    fallbackPatterns.push(`brand:${brands[0]},collection:*`);
    fallbackPatterns.push(`brand:*,collection:${collections[0]}`);
    fallbackPatterns.push('brand:*,collection:*');
  } else {
    if (brands.length > 0) {
      fallbackPatterns.push(`brand:${brands[0]}`);
      fallbackPatterns.push('brand:*');
    }
    if (collections.length > 0) {
      fallbackPatterns.push(`collection:${collections[0]}`);
      fallbackPatterns.push('collection:*');
    }
  }

  // Try each fallback pattern
  for (const pattern of fallbackPatterns) {
    match = collectionConfigs.find(config => config.criteria === pattern);
    if (match) {
      return match;
    }
  }
  
  // No match found - return null instead of falling back to default
  return null;
};

const replacePlaceholders = (text, collections, brands) => {
  return text
    .replace(/{brand}/g, brands.length > 0 ? brands[0] : 'Brand')
    .replace(/{collection}/g, collections.length > 0 ? collections[0] : 'Collection');
};

const searchDescriptionService = {
  getSearchDescription: (collections, brands, metaData) => {
    const matchingCollection = findMatchingDetails(collections, brands, metaData);
    
    if (!matchingCollection) {
      return null;
    }

    const title = replacePlaceholders(matchingCollection.title, collections, brands);
    const subtitle = replacePlaceholders(matchingCollection.subtitle, collections, brands);
    const description = replacePlaceholders(matchingCollection.description, collections, brands);

    return { title, subtitle, description };
  },
};

export default searchDescriptionService;